/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommentingConfig } from '../../../../state/thunks/commenting';
// utils
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
import SiteFilter from '../../../../material/sitefilter/sitefilter';
import LoadingState from '../../../../material/states/loading/loading';
// content
import CommentingAddOnsSection from './addons/addons'
import CommentsTreeSection from './commentstreesection/commentstreesection';
import ColorSchemeSection from './colorschemesection/colorschemesection';
import UserAvatarSection from './useravatarsection/useravatarsection';
import CommunitySection from './communitysection/communitysection';
import ModerationSection from './moderationsection/moderationsection';
import GeneralSection from './generalsection/generalsection';
// styles
import injectSheet from "react-jss";
import styles from './commentingconfig_styles.js';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG PAGE ~~~~~~~~~~ ========== */
const CommentingConfigPage = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { sites } = useSelector(state => state.account) 
  const { siteUUID, accountUUID } = useSelector(state => state.session);
  const { commentingConfig } = useSelector(state => state.commenting)

  const [isLoading,setIsLoading] = useState(true)

  useEffect(() => {
    if(accountUUID && siteUUID) loadCommentingConfig()
  }, [accountUUID, siteUUID]) 

  const loadCommentingConfig = useCallback(async()=>{
    const response = await dispatch(fetchCommentingConfig({accountUUID, siteUUID, siteURL: sites[siteUUID] }))
    setIsLoading(false)
  }, [siteUUID, accountUUID])

  return (
    <Page name={'commentingconfigpage'} klass={`${props.classes.commentingconfigpage}`}>
      <SiteFilter />
      <Content>
        <InContentMessage />
        <PageHeader title={'Commenting'} subtitle={'Configuration'}  />
        <PageContent>
        { isLoading || commentingConfig.status === 'pending' ?
          <LoadingState />
          :
          <>
            <GeneralSection />
            <ModerationSection />
            <CommentsTreeSection />
            <ColorSchemeSection />
            <UserAvatarSection />
            <CommunitySection />
            <CommentingAddOnsSection />
          </>
        }
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentingConfigPage